import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ApplicationInfoComponent } from "./application-info/application-info.component";
import { AssignmentDetailsComponent } from "./assignment-details/assignment-details.component";
import { CandidateProgressComponent } from "./candidateprogress/candidateprogress.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LearningObjectiveInfoComponent } from "./learning-objective-info/learning-objective-info.component";
import { LoginComponent } from "./login/login.page.component";
import { OrderLearningObjectivesComponent } from "./order-learning-objectives/order-learning-objectives.component";
import { PlanningComponent } from "./planning/planning.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { CitoModuleGuard } from "./shared/guards/citomodule.guard";
import { TeacherAuthGuard } from "./shared/guards/teacher.guard";

export const routes = [
  {
    path: "loggedin",
    component: LoginComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard, TeacherAuthGuard],
  },
  {
    path: "plan",
    component: PlanningComponent,
    children: [
      {
        path: "learningObjective/:code",
        component: LearningObjectiveInfoComponent,
      },
      {
        path: "candidateprogress/:id",
        component: CandidateProgressComponent,
        outlet: "candidateprogress",
      },
      {
        path: "details/:id", // id is assignmentId here.
        component: AssignmentDetailsComponent,
      },
    ],
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "domains",
    component: OrderLearningObjectivesComponent,
    children: [
      {
        path: "learningObjective/:code",
        component: LearningObjectiveInfoComponent,
      },
    ],
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "domains/:id",
    component: OrderLearningObjectivesComponent,
    children: [
      {
        path: "learningObjective/:code",
        component: LearningObjectiveInfoComponent,
      },
    ],
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "learningobjective",
    component: OrderLearningObjectivesComponent,
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "learningobjective/:id",
    component: OrderLearningObjectivesComponent,
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "info",
    component: ApplicationInfoComponent,
    canActivate: [AuthGuard, TeacherAuthGuard, CitoModuleGuard],
  },
  {
    path: "**",
    redirectTo: "/login",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
